import DashboardIcon from "@mui/icons-material/Dashboard";
import AssignmentIcon from "@mui/icons-material/Assignment";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import FileOpenIcon from "@mui/icons-material/FileOpen";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import SafetyDividerIcon from "@mui/icons-material/SafetyDivider";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import Groups2Icon from "@mui/icons-material/Groups2";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SettingsIcon from "@mui/icons-material/Settings";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import GavelRoundedIcon from "@mui/icons-material/GavelRounded";
import Diversity3Icon from '@mui/icons-material/Diversity3';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ContactPageIcon from '@mui/icons-material/ContactPage';
import CalculateRoundedIcon from "@mui/icons-material/CalculateRounded";
import WorkspacesRoundedIcon from "@mui/icons-material/WorkspacesRounded";
import FolderCopyRoundedIcon from "@mui/icons-material/FolderCopyRounded";

export const ICONS = {
  dashboard: DashboardIcon,
  assignment: AssignmentIcon,
  newspaper: NewspaperIcon,
  fileOpen: FileOpenIcon,
  requestQuote: RequestQuoteIcon,
  lawsuit: SafetyDividerIcon,
  emojiPeople: EmojiPeopleIcon,
  accountBalance: AccountBalanceIcon,
  groups: Groups2Icon,
  adminPanel: AdminPanelSettingsIcon,
  settings: SettingsIcon,
  attachment: AttachFileIcon,
  gavel: GavelRoundedIcon,
  parties: Diversity3Icon,
  judicialAccounts: AccountBalanceWalletIcon,
  certificatesNotifications: ContactPageIcon,
  liquidations: CalculateRoundedIcon,
  workspace: WorkspacesRoundedIcon,
  documents: FolderCopyRoundedIcon,
  //safetyDivide: SafetyDividerIcon,
};

export function NavIcon({ iconKey, sx }) {
  const Icon = ICONS[iconKey] || DashboardIcon;
  return <Icon sx={sx} />;
}